export enum Components {
  EMAIL = 'EMAIL_COMPONENTS'
}
